import React from "react";
import {Button, Grid, Header, Icon, List, Form, Message, Progress} from "semantic-ui-react";

function AddPronunciationComponent(
    {
        soundsList,
        handleSubmit,
        handleChange,
        nameButtons,
        success,
        fileNames,
        buttons,
        error,
        progress,
        progressText,
        loading,
        handleBackToSounds,
        classLevel,
    }
) {
    return (
        <>
            <br/>
            <Button onClick={handleBackToSounds} icon color='black' style={{marginLeft: 5, marginTop: 5}}><Icon name='arrow left'/>Back</Button>
            <Grid centered={true}>
                <Grid.Row>
                    <Header as='h1' style={{color: 'black'}}>
                        Create Pronunciation Assignment
                    </Header>
                </Grid.Row>
                <Message color='blue'>
                    <Header as='h2' textAlign='left' color='black'>
                        <h2 style={{color: 'black'}}>
                            Directions:
                        </h2>
                    </Header>
                    <p style={{textAlign: 'left', color: "black"}}>
                        Use the input "Choose Files" below to select the audio files to be used in the assignment, then click the button "Choose Sound Files".<br/>
                        Once all the audio files are listed in the section "Chosen Sound Files", click the button "Build Assignment".<br/><br/>
                        Once the sounds have finished uploading, you will need to label the audio buttons.<br/>
                        This label will show up as the button name on the pronunciation page.<br/>
                    </p>
                </Message>
                {
                    success ?
                        <Grid.Row>
                            <Message positive>
                                <Message.Header>Assignment has been uploaded to the Pronunciation page</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    error ?
                        <Grid.Row>
                            <Message negative>
                                <Message.Header>{error}</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    loading ?
                        <Grid.Row>
                            <Progress style={{width: 400}} indicating progress percent={progress}>
                                {progressText}
                            </Progress>
                        </Grid.Row>
                        :
                        null
                }
                <Grid.Row columns={7}>
                        <Grid.Column>
                            <Header as='h5'>Label: </Header>
                            {nameButtons.map((item, index) => (
                                <>

                                    <Grid.Row style={{marginTop:5}}>
                                        <Form.Input
                                            id={index}
                                            onChange={handleChange}
                                            value={nameButtons[index]}
                                            name={index}
                                        />
                                    </Grid.Row>

                                </>
                            ))}
                        </Grid.Column>
                        <Grid.Column>
                            <Header as='h5'>Sound of Button: </Header>
                            {soundsList.map((item, index) => (
                                <>
                                    <Grid.Row style={{marginTop:5}}>
                                        <Form.Input
                                        placeholder={item.name}
                                        readOnly
                                        >
                                            <Form.Input
                                                placeholder={item.name}
                                                readOnly
                                            />
                                        {buttons[index]}
                                        </Form.Input>
                                    </Grid.Row>

                                </>
                            ))}
                        </Grid.Column>
                        <Grid.Row>
                        </Grid.Row>
                </Grid.Row>
                <Button onClick={handleSubmit} size='large' color='green'>Upload Assignment</Button>


            </Grid>
        </>
    )
}

export default AddPronunciationComponent
